document.addEventListener('DOMContentLoaded', function () {

    gsap.set('.co_ourstory_section_2-images--left', { xPercent: 0, transition: 0 });
    gsap.to('.co_ourstory_section_2-images--left', {
        scrollTrigger: {
            trigger: '.co_ourstory_section_2',
            endTrigger: '.co_ourstory_section_2',
            start: '-20% top',
            end: "bottom top",
            scrub: true
        },
        yPercent: 6
    });

    gsap.set('.co_ourstory_section_2-images--right', { xPercent: 0, transition: 0 });
    gsap.to('.co_ourstory_section_2-images--right', {
        scrollTrigger: {
            trigger: '.co_ourstory_section_2',
            endTrigger: '.co_ourstory_section_2',
            start: '-20% top',
            end: "bottom top",
            scrub: true
        },
        yPercent: -6
    });
    
});